// Analytics consent for visitors where it is required (EU, EEA, UK,
// Switzerland). Same country list as fexrapi link_controller._CONSENT_REQUIRED.

export const CONSENT_COOKIE = "fexr_analytics_consent";
export const CONSENT_REGION_COOKIE = "fexr_consent_region";
export const CONSENT_EVENT = "fexr:analytics-consent";

export const CONSENT_REQUIRED_COUNTRIES = new Set([
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "IS",
  "LI",
  "NO",
  "GB",
  "CH",
]);

export function consentRequiredFor(
  country: string | null | undefined,
): boolean {
  const c = country?.toUpperCase();
  return !!c && CONSENT_REQUIRED_COUNTRIES.has(c);
}

/** What to send as `analytics_consent` on a link open, or undefined to omit. */
export function analyticsConsentFor(
  country: string | null | undefined,
  cookie: string | null | undefined,
): boolean | undefined {
  if (cookie === "1") return true;
  if (cookie === "0") return false;
  const c = country?.toUpperCase();
  if (!c || c === "XX" || c === "T1") return undefined;
  return !CONSENT_REQUIRED_COUNTRIES.has(c);
}

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const hit = document.cookie
    .split("; ")
    .find((part) => part.startsWith(`${name}=`));
  return hit ? decodeURIComponent(hit.slice(name.length + 1)) : null;
}

export function consentChoice(): boolean | null {
  const value = readCookie(CONSENT_COOKIE);
  return value === "1" ? true : value === "0" ? false : null;
}

export function consentRegion(): boolean {
  return readCookie(CONSENT_REGION_COOKIE) === "1";
}

export function setConsentChoice(accepted: boolean): void {
  if (typeof document === "undefined") return;
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${CONSENT_COOKIE}=${accepted ? "1" : "0"}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: accepted }));
}
